module.exports = __webpack_public_path__ + "img/EOTP_yeti_peek.3d3301f5.gif";